import { useTranslation } from 'react-i18next';
import { SparklingFillIcon } from '@zep-us/zus-icons';
import { useAuth } from '@zep/auth';
import { PagePath } from '@zep/common/routes';
import { Button, Toggle } from '@zep/ui';
import { isTablet } from '@zep/utils';
import { ExportIcon, HammerIcon } from '../../../icons';
interface CreateSpaceHeaderProps {
  showPurchasedMaps: boolean;
  onToggleChange: (checked: boolean) => void;
  onClickNoTemplate?: () => void;
  onClickAiGenerate?: () => void;
}
export const CreateSpaceHeader = ({
  showPurchasedMaps,
  onToggleChange,
  onClickNoTemplate,
  onClickAiGenerate
}: CreateSpaceHeaderProps) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    user
  } = useAuth();
  const isEdu = user?.isEdu ?? false;
  return <div className="flex flex-row justify-between pb-[16px] pl-[10px] pr-[20px] pt-[30px]" data-sentry-component="CreateSpaceHeader" data-sentry-source-file="CreateSpaceHeader.tsx">
      <h1 className="text-[18px] font-bold text-gray-900">
        {t('common:createSpace.header')}
      </h1>
      <div className="flex flex-row items-center gap-xs">
        <div className="px-sm">
          <Toggle checked={showPurchasedMaps} onChange={(e: React.ChangeEvent<HTMLInputElement>) => onToggleChange(e.target.checked)} label={<span className="text-[14px] font-semibold text-gray-600">
                {isEdu ? t('common:mapTemplateModal.eduMap') : t('common:mapTemplateModal.purchaseMap')}
              </span>} labelPlacement="left" data-sentry-element="Toggle" data-sentry-source-file="CreateSpaceHeader.tsx" />
        </div>
        {onClickAiGenerate && !isTablet() && <Button as="button" variant="primary" size="sm" leftSlot={<SparklingFillIcon width={16} height={16} />} onClick={onClickAiGenerate}>
            AI로 생성하기
          </Button>}
        {onClickNoTemplate && !isTablet() && <Button as="button" variant="secondary" size="sm" leftSlot={<HammerIcon width={16} height={16} />} onClick={onClickNoTemplate}>
            {t('common:mapTemplateModal.emptyTemplate')}
          </Button>}
        <Button as="a" variant="sub" size="sm" leftSlot={<ExportIcon width={16} height={16} />} href={PagePath.AssetStore} target="_blank" data-sentry-element="Button" data-sentry-source-file="CreateSpaceHeader.tsx">
          {t('common:mapTemplateModal.assetStore')}
        </Button>
      </div>
    </div>;
};